import { render } from "./ModuleEdit.vue?vue&type=template&id=01454c29"
import script from "./ModuleEdit.vue?vue&type=script&lang=js"
export * from "./ModuleEdit.vue?vue&type=script&lang=js"

import "./ModuleEdit.vue?vue&type=style&index=0&id=01454c29&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__